import {store} from '@/vuex/store/store';

const moduleLoaders = new Map();
const modulePromises = new Map();
const loadedModules = new Set();

/**
 * Register a lazy Vuex module
 */
export function registerLazyModule(name, loader) {
    moduleLoaders.set(name, loader);
}

/**
 * Ensure the module is loaded (idempotent)
 */
export function ensureModule(name) {

    if (loadedModules.has(name)) {
        return Promise.resolve();
    }

    if (modulePromises.has(name)) {
        return modulePromises.get(name);
    }

    const loader = moduleLoaders.get(name);

    if (!loader) {
        console.warn(`[Vuex] No loader registered for module: ${name}`);
        return Promise.resolve();
    }

    const promise = loader()
        .then(mod => {
            const module = mod.default || mod;

            // important: double safety
            if (!store.hasModule(name)) {
                store.registerModule(name, module);
            }

            loadedModules.add(name);
        })
        .catch(err => {
            console.error(`[Vuex] Failed to load module: ${name}`, err);
            throw err;
        })
        .finally(() => {
            modulePromises.delete(name);
        });

    modulePromises.set(name, promise);

    return promise;
}

export function isModuleLoaded(name) {
    return loadedModules.has(name);
}

export {store};
